(ns app.front.view.admin.domain-groups.common
  (:require [app.i18n.model :as i18n-model]
            [clojure.string :as str]))

(defn municipality-numbers-unique? [municipalities]
  (->> municipalities
       (keep :number)
       (map str/trim)
       frequencies
       vals
       (every? (partial = 1))))


(defn valid-municipality? [coords {:keys [name official-name number location]}]
  (and (not (i18n-model/blank? official-name))
       (not (i18n-model/blank? name))
       (not (str/blank? number))
       (or (get coords number) (vector? location))))
